// Framework-free core of pageTitle — the route→document-title mapping,
// extracted so it can be unit-tested with Node's built-in runner (pageTitle.js
// itself imports react/react-router and can't be imported into node --test).
// Mirrors the dataBrowserLogic.mjs precedent.

export const APP_NAME = 'IEWRS'
export const TAGLINE = 'Integrated Early Warning and Response System'

// Longest match wins, so /app/schema/tables beats /app/schema.
export const TITLES = {
  '/': null, // the landing page is the brand itself — no page suffix
  '/login': 'Sign in',
  '/register': 'Create account',
  '/request-access': 'Request access',
  '/forgot-password': 'Reset password',
  '/set-password': 'Set password',

  '/app/dashboard': 'Dashboard',
  '/app/account': 'My account',
  '/app/alerts/detector': 'Alert Detector',
  '/app/alerts': 'Alerts',
  '/app/forecast-map': 'Forecast Severity Map',
  '/app/system': 'System Overview',

  '/app/models/notebooks': 'Upload notebook',
  '/app/models': 'Models',

  '/app/data/import': 'Import data',
  '/app/data/browse': 'Browse data',

  '/app/schema/tables': 'Tables',
  '/app/schema/migrations': 'Migrations',
  '/app/schema': 'Schema',

  '/app/analytics/visual-creator': 'Visual Creator',
  '/app/analytics/saved-visuals': 'Saved visuals',

  '/app/settings/content/landing-content': 'Landing content',
  '/app/settings/content/images': 'Marketing images',
  '/app/settings/people/users': 'Users',
  '/app/settings/people/roles': 'Roles & Permissions',
  '/app/settings/people/access-requests': 'Access requests',
  '/app/settings/runtime': 'Maps & Locale',
  '/app/settings/alerts/notifications': 'Alert Notifications',

  '/app/admin/users': 'Users',
  '/app/admin/access-requests': 'Access requests',
  '/app/admin/alerts-config': 'Alert detector',
  '/app/admin': 'Administration',
}

// Shared longest-match lookup — the bare page label (e.g. "Schema"), or
// null when nothing matches. Both titleForPath (document.title) and
// pageNameForPath (the navbar's heading) derive from this so the two can
// never drift onto different labels for the same route.
function matchedPage(pathname) {
  if (pathname === '/') return null
  const match = Object.keys(TITLES)
    .filter((route) => route !== '/' && (pathname === route || pathname.startsWith(`${route}/`)))
    .sort((a, b) => b.length - a.length)[0]
  return match ? TITLES[match] : null
}

export function titleForPath(pathname) {
  if (pathname === '/') return `${APP_NAME} — ${TAGLINE}`
  const page = matchedPage(pathname)
  return page ? `${APP_NAME} | ${page}` : `${APP_NAME} — ${TAGLINE}`
}

// Bare page label for the app shell's navbar heading (Header.jsx) — no
// "IEWRS |" prefix, since that's redundant next to the sidebar's own logo.
// Returns null for the landing route or any unmatched path; callers supply
// their own fallback label for the latter.
export function pageNameForPath(pathname) {
  return matchedPage(pathname)
}
